import AppConstants from '../constants/AppConstants';

export const initialState = false;

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case AppConstants.IS_NAV_EXTENDED:
            return action.isNavExtended;

        default:
            return state;
    }
};
